const PONDERATION_VALUES = {
  hogar: '90',
  coche: '80',
  moto: '70',
  vida: '99'
}
const PONDERATION_DEFAULT_VALUE = '1'

export function setPonderation() {
  const ponderation =
    Object.entries(PONDERATION_VALUES)
      .map(([key, value]) => {
        return window.location.href.includes(key) ? value : null
      })
      .filter((item) => item !== null)
      .join('') || PONDERATION_DEFAULT_VALUE

  return ponderation
}
